import { FieldErrors } from './FieldErrors';

import { useFieldContext } from '.';

interface Props {
  autoFocus?: boolean;
  label: string;
  min?: string;
  noLabel?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  step?: string;
  type?: 'email' | 'password' | 'number' | 'text' | 'tel' | 'date';
  value?: string;
}

export function MonsterTextField({
  autoFocus,
  label,
  min,
  noLabel,
  onChange,
  placeholder,
  required = true,
  step,
  type = 'text',
  value
}: Props) {
  const field = useFieldContext<string>();

  return (
    <div>
      <label htmlFor={field.name} className={`block leading-6 font-medium ${noLabel ? 'sr-only' : ''}`}>
        {label}
      </label>
      <div className='mt-2'>
        <input
          step={step}
          autoFocus={autoFocus}
          min={min}
          onChange={onChange ? onChange : (e) => field.handleChange(e.target.value)}
          value={value ? value : field.state.value}
          required={required}
          id={field.name}
          name={field.name}
          type={type}
          placeholder={placeholder}
          className='ring-monsterPurple focus:ring-monsterGreen text-siteBackground nice-focus block w-full rounded-lg border-0 bg-white px-3 py-2 ring-2 transition-all duration-200 ease-in-out outline-none ring-inset placeholder:text-gray-400 focus:ring-inset'
        />
      </div>
      <FieldErrors meta={field.state.meta} />
    </div>
  );
}
